"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorSurge = void 0;
var _react = _interopRequireWildcard(require("react"));
var _framerMotion = require("framer-motion");
var _hint = require("@cbhq/cds-common/motion/hint");
var _layout = require("../layout");
var _useMotionProps = require("./useMotionProps");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const MotionBox = (0, _framerMotion.m)(_layout.Box);

/**
 * Please consult with the motion team in #ask-motion before using this component.
 */
const ColorSurge = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function ColorSurge({
  background = 'primary',
  disableAnimateOnMount = false
}, ref) {
  const _useState = (0, _react.useState)(background),
    backgroundState = _useState[0],
    setBackgroundState = _useState[1];
  const controls = (0, _framerMotion.useAnimation)();
  const motionProps = (0, _useMotionProps.useMotionProps)({
    enterConfigs: [_hint.colorSurgeEnterConfig],
    exitConfigs: [_hint.colorSurgeExitConfig],
    animate: controls
  });
  const playAnimation = (0, _react.useCallback)(async backgroundParam => {
    if (backgroundParam) {
      setBackgroundState(backgroundParam);
    }
    controls.set('enter');
    await controls.start('exit');
  }, [controls]);
  (0, _react.useEffect)(() => {
    if (!disableAnimateOnMount) {
      void playAnimation();
    }
  }, [playAnimation, disableAnimateOnMount]);
  (0, _react.useImperativeHandle)(ref, () => ({
    play: playAnimation
  }), [playAnimation]);
  return /*#__PURE__*/_react.default.createElement(MotionBox, {
    animate: controls,
    background: backgroundState,
    initial: disableAnimateOnMount ? 'exit' : 'enter',
    pin: "all",
    variants: motionProps.variants
  });
}));
exports.ColorSurge = ColorSurge;